import { DetectedCoreHostService } from './detected.core.host.service';
import { environment } from '../../environments/environment';
import {Injectable} from '@angular/core';
//
// export namespace APP {
//   export const PORT = '8989';
//   export const BASE_URL = '212.1.112.236'; // '172.16.124.72' // localhost
// }
@Injectable()
export class Constants {

  PORT = '8989';
  BASE_URL = '212.1.112.236'; // '172.16.124.72' // localhost

  listDevices: string = '//' + this.setUrl() + ':' + this.PORT; // http://lorawan-rtx-this.gaportal.xyz:8989
  deviceInf: string =  '//' + this.setUrl() + ':' + this.PORT; // http://lorawan-rtx-this.gaportal.xyz:8989
  loginSet: string = '//' + this.setUrl() + ':' + this.PORT;  // http://lorawan-rtx-this.gaportal.xyz:8989
  setCongigDevice: string = '//' + this.setUrl() + ':' + this.PORT;   // http://lorawan-rtx-this.gaportal.xyz:8989
  setAllReceipt: string = '//' + this.setUrl() + ':' + this.PORT;    // http://lorawan-rtx-this.gaportal.xyz:8989
  getReceiptDetail: string = '//' + this.setUrl() + ':' + this.PORT;    // http://lorawan-rtx-this.gaportal.xyz:8989
  getInfoService: string = '//' + this.setUrl() + ':' + this.PORT;    //
  getInfoServiceSelected: string = '//' + this.setUrl() + ':' + this.PORT;    // http://lorawan-rtx-this.gaportal.xyz:8989
  applicationID: string = '3';   // TODO template
  limit: string = '999';        // TODO template

  constructor(public host: DetectedCoreHostService) {}

  public setUrl(): string {
    if (environment.docker) return this.host.getHost();
    else return '212.1.112.236';
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/services/constants-service.ts